import { apiClient } from './client';
import { ContractComment } from '../types/contractComment';

export async function fetchContractComments(
  contractId: number,
  stageId?: number | null
): Promise<ContractComment[]> {
  const { data } = await apiClient.get<ContractComment[]>(`/contracts/${contractId}/comments`, {
    params: stageId != null ? { stageId } : undefined,
  });
  return data;
}

export async function createContractComment(
  contractId: number,
  content: string,
  files: File[],
  stageId?: number | null
): Promise<ContractComment> {
  const formData = new FormData();
  if (content.trim()) {
    formData.append('content', content.trim());
  }
  if (stageId != null) {
    formData.append('stageId', String(stageId));
  }
  files.forEach((file) => formData.append('files', file));
  const { data } = await apiClient.post<ContractComment>(
    `/contracts/${contractId}/comments`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}

export async function deleteContractComment(contractId: number, commentId: number): Promise<void> {
  await apiClient.delete(`/contracts/${contractId}/comments/${commentId}`);
}

export async function downloadContractCommentAttachment(
  contractId: number,
  commentId: number,
  attachmentId: number,
  fileName: string
): Promise<void> {
  const { data } = await apiClient.get<Blob>(
    `/contracts/${contractId}/comments/${commentId}/attachments/${attachmentId}/download`,
    { responseType: 'blob' }
  );
  const url = window.URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  window.URL.revokeObjectURL(url);
}
